import React, { lazy } from 'react'
import Loadable from 'app/components/Loadable/Loadable'
import { authRoles } from '../../auth/authRoles'
import UserInfo from './userinfo'

const Diagnosis = Loadable(lazy(() => import('./diagnosis')))

const diagRoutes = [
    {
        path: '/diagnosis',
        element: <Diagnosis />,
        auth: authRoles.editor,
    },
    {
        path: '/diagnosis/default',
        element: <Diagnosis />,
        auth: authRoles.editor,
    },
    {
        path: '/diagnosis/userinfo',
        element: <UserInfo />,
        auth: authRoles.editor,
    }
]

export default diagRoutes
